import React, { useCallback, useEffect, useState, useRef } from "react";
import MainLayout from "../../layout/mainLayout";
import "./index.scss";
import InsuranceCard from "./component/variantCards";
import Filter from "./component/filter";
import AddOns from "./component/addons";
import { useLocation } from "react-router-dom";
import { getAllProductVariants } from "../../service/productVariant/productVariant";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentPage,
  setInsuranceData,
} from "../../store/slices/insurance/insuranceSlice";
import Loader from "../../components/common/loader";
import {
  DownCarrot,
  FilterDrawerIcon,
  UpCarrot,
} from "../../assets/images/svg/svg";
import {
  clearExistingToken,
  customSortStyles,
  getCodeFromUrl,
  getParamsFromURL,
} from "../../utils/helper";
import NoDataFound from "../../components/NoDataFound";
import Select from "react-select";
import Filter1 from "./component/filter/filter";
import { Dropdown } from "react-bootstrap";
import Checkbox from "../../components/common/FormFields/checkbox";
import { useForm } from "react-hook-form";
import { getProductAttributes } from "../../service/productVariant/filterService";
import { setLoading } from "../../store/slices/commonSlice";
import { AG_CODE } from "../../utils/commonConstant";

function ProductVariant() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [isDetailsVisible, setIsDetailsVisible] = useState(true);
  const toggleDetailsVisibility = () => {
    setIsDetailsVisible(!isDetailsVisible);
  };
  const loading = useSelector((state) => state.common.loading);
  const insuranceData = useSelector((state) => state.insurance.insuranceData);
  const productName = useSelector((state) => state.product.productName);
  const [checkedAddOns, setCheckedAddOns] = useState({});
  const [filterValues, setFilterValues] = useState({});
  const [selectedOem, setSelectedOem] = useState([]);
  const [addOnOptions, setAddOnOptions] = useState({});
  const [combinedData, setCombinedData] = useState({});
  const [sortField, setSortField] = useState("");
  const [sortType, setSortType] = useState("");
  const [entityid, setEntityid] = useState(null);
  const [show, setShow] = useState(false);
  const handleFilter = () => setShow(!show);
  const currentPage = useSelector((state) => state.insurance.currentPage);
  const pageSize = useSelector((state) => state.insurance.pageSize);
  const totalPages = useSelector(
    (state) => state.insurance?.insuranceData?.totalPages
  );
  const [dropdown, setDropdown] = useState(false);
  const attributeForm = useSelector(
    (state) => state.product.attributeForm.formState
  );
  const {
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const productAttributes = useSelector(
    (state) => state.product.productAttributes
  );
  const agCode = getCodeFromUrl();

  const totalElements = useSelector(
    (state) => state.insurance?.insuranceData?.totalElements
  );
  const doctorCategory = useSelector(
    (state) => state.product.attributeLov.default_values
  );

  // const productAttributes = useSelector(
  //   (state) => state.product.productAttributes
  // );

  useEffect(() => {
    const fetchCode = async () => {
      const urlCode = await getParamsFromURL(location, "entityid");
      setEntityid(urlCode); // Set the code once it's fetched
    };
    fetchCode();
  }, [location]);

  const updateCombinedData = useCallback(
    (filterValues, addOnOptions, selectedOem) => {
      const combinedPayload = {};
      // Merge filter values
      Object.keys(filterValues).forEach((id) => {
        Object.assign(combinedPayload, filterValues[id]);
        if (combinedPayload.doctor_category && doctorCategory) {
          combinedPayload.doctor_category = doctorCategory;
        }
      });

      // Merge add-on options
      Object.keys(addOnOptions).forEach((id) => {
        const addOnOption = addOnOptions[id];
        Object.keys(addOnOption).forEach((key) => {
          combinedPayload[key] = addOnOption[key].checked;
        });
      });

      // Add oem_ids if present
      if (selectedOem.length > 0) {
        combinedPayload.oem_id = selectedOem.join(",");
      }

      setCombinedData(combinedPayload);
    },
    [doctorCategory]
  );

  const handleAddOnsChange = useCallback(
    (addOns) => {
      setAddOnOptions((prevOptions) => {
        const newOptions = { ...prevOptions, ...addOns };
        setCheckedAddOns(newOptions); // Update checkedAddOns if needed
        dispatch(setCurrentPage(0));
        updateCombinedData(filterValues, newOptions, selectedOem);
        return newOptions;
      });
    },
    [filterValues, selectedOem, updateCombinedData]
  );

  useEffect(() => {
    const fetchData = async () => {
      if (entityid) {
        dispatch(setLoading(true));

        try {
          await getAllProductVariants(
            entityid,
            attributeForm,
            sortField,
            sortType,
            currentPage,
            pageSize,
            selectedOem
          );
        } catch (error) {
          console.error("Error fetching product variants:", error);
        } finally {
          dispatch(setLoading(false));
        }
      }
    };

    fetchData();
  }, [
    entityid,
    attributeForm,
    sortField,
    sortType,
    currentPage,
    pageSize,
    filterValues,
    selectedOem
  ]);

  const sortOptions = [
    { value: "cover_DESC", label: "Cover - High to Low" },
    { value: "cover_ASC", label: "Cover - Low to High" },
    { value: "premium_DESC", label: "Premium - High to Low" },
    { value: "premium_ASC", label: "Premium - Low to High" },
  ];

  const handleSortChange = (selectedOption) => {
    if (!selectedOption) {
      setSortField("");
      setSortType("");
      return;
    }

    const [field, type] = selectedOption.value.split("_");
    setSortField(field);
    setSortType(type);
  };

  const products = insuranceData?.content || [];

  const handlePageChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const oemOptions = Array.isArray(productAttributes)
    ? productAttributes.flatMap(
      (child) =>
        child.pspOem?.map((oem) => ({
          entityid: oem.entityid,
          name: oem.name,
        })) || []
    )
    : productAttributes?.pspOem?.map((oem) => ({
      entityid: oem.entityid,
      name: oem.name,
    })) || [];

  useEffect(() => {
    if (entityid) {
      getProductAttributes(entityid);
    }
  }, [entityid]);

  const handleChange = (name, isChecked) => {
    const selectedOption = oemOptions.find((option) => option.name === name);

    if (selectedOption) {
      const { entityid } = selectedOption;

      setSelectedOem((prev) => {
        if (isChecked) {
          return prev.includes(entityid) ? prev : [...prev, entityid];
        } else {
          return prev.filter((id) => id != entityid);
        }
      });
    }
  };

  return (
    <MainLayout>
      <div className="insurance--container">
        <div className="row">
          <div className="col-xl-3 col-12">
            <div className="insurance--widget">
              <Filter1 />
            </div>
          </div>
          <div className="col-xl-9 col-12">
            <div className="insurance--content--body">
              <div className="insurance--content--header">
                <h1 className="insurance--content--title">{productName}</h1>
                <div className="insurance--content-right">
                  {agCode !== AG_CODE && (
                    <>
                      <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic">
                          <span>Insurance Company</span>
                          <span className="dropdown-icon">
                            {dropdown ? <UpCarrot /> : <DownCarrot />}
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <div className="oem--container">
                            <div className="oem---body">
                              <Checkbox
                                className="checkbox-group"
                                options={oemOptions}
                                control={control}
                                errors={errors}
                                onInputChange={(name, isChecked) =>
                                  handleChange(name, isChecked)
                                }
                              />
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                      <Select
                        options={sortOptions}
                        onChange={handleSortChange}
                        isClearable
                        placeholder="Sort By"
                        classNamePrefix="react-select"
                        styles={customSortStyles}
                      />

                    </>
                  )}
                  <button
                    className="filter-button-container"
                    onClick={() => handleFilter()}
                  >
                    <FilterDrawerIcon />
                  </button>
                </div>
                {/* <div className="insurance--content-right">
                  <ToggleButton />
                  <div />
                </div> */}
              </div>
              <>
                {loading || !insuranceData ? (
                  <Loader />
                ) : products.length > 0 ? (
                  <div className="row insurance--content__row">
                    {products.map((data, index) => (
                      <div className="col-xl-4 col-md-6 col-11" key={index}>
                        <InsuranceCard
                          {...data}
                          isDetailsVisible={isDetailsVisible}
                        // toggleDetailsVisibility={toggleDetailsVisibility}
                        // type={productAttributes ? productAttributes.type : {}}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <NoDataFound />
                )}
                {/* <Compare /> */}
              </>
              {totalElements > 9 && (
                <div className="pagination-controls">
                  <button
                    onClick={() =>
                      handlePageChange(Math.max(currentPage - 1, 0))
                    }
                    disabled={currentPage === 0}
                  >
                    Previous
                  </button>
                  <span>
                    Page {currentPage + 1} of {totalPages}
                  </span>
                  <button
                    onClick={() =>
                      handlePageChange(
                        Math.min(currentPage + 1, totalPages - 1)
                      )
                    }
                    disabled={currentPage >= totalPages - 1}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>


      {/* <Offcanvas
        show={show}
        onHide={handleFilter}
        placement="bottom"
        className="filter-offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body closeButton>
          <>
            <Filter
              onFilterChange={handleFilterChange}
              setSelectedOem={setSelectedOem}
            />
            <AddOns
              addOnOptions={addOnOptions}
              setAddOnOptions={setAddOnOptions}
              onAddOnsChange={handleAddOnsChange}
            />
          </>
        </Offcanvas.Body>
      </Offcanvas> */}
      <div
        className={`offcanvas offcanvas-bottom filter-offcanvas ${show ? "show" : "hide"
          }`}
        tabIndex="-1"
        id="offcanvasBottom"
        aria-labelledby="offcanvasBottomLabel"
        role="dialog"
        aria-modal={show ? "true" : "false"}
      >
        <div class="offcanvas-header">
          <h5 id="offcanvasBottomLabel">Filters</h5>
          <button
            onClick={handleFilter}
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body">
          <>
            <Filter1 />
          </>
        </div>
      </div>
    </MainLayout>
  );
}

export default ProductVariant;
